export default {
      id: "unit_dashboard__main_power-usage",
      viewBox: "0 0 52 52",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__main_power",
      toString: function () {
        return this.url;
      }
    }